(() => {
  const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  if (connection?.saveData) document.documentElement.classList.add('tc-save-data');

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const heroVideos = [...document.querySelectorAll('[data-tc-hero-video]')];
  const mobileHero = window.matchMedia('(max-width: 749px)');

  const unloadHeroVideo = (video) => {
    if (!video.dataset.tcVideoLoaded) return;
    video.pause();
    video.querySelectorAll('source').forEach((source) => source.removeAttribute('src'));
    delete video.dataset.tcVideoLoaded;
    video.load();
  };

  const loadHeroVideo = (video) => {
    if (!video || video.dataset.tcVideoLoaded) return;
    video.querySelectorAll('source[data-tc-video-src]').forEach((source) => {
      source.src = source.dataset.tcVideoSrc;
    });
    video.dataset.tcVideoLoaded = 'true';
    video.load();
    video.play().catch(() => {});
  };

  const syncHeroVideo = () => {
    if (reduceMotion.matches || connection?.saveData) {
      heroVideos.forEach(unloadHeroVideo);
      return;
    }
    const target = mobileHero.matches ? 'mobile' : 'desktop';
    heroVideos.forEach((video) => {
      if (video.dataset.tcHeroVideo === target) loadHeroVideo(video);
      else unloadHeroVideo(video);
    });
  };

  if (heroVideos.length) {
    syncHeroVideo();
    if (mobileHero.addEventListener) mobileHero.addEventListener('change', syncHeroVideo);
    else mobileHero.addListener(syncHeroVideo);
  }

  const transparentHeader = document.querySelector('#header-component[transparent="not-sticky"]');
  if (transparentHeader) {
    const scrollRoot = document.querySelector('.page-wrapper');
    const syncHeader = () => {
      const scrollPosition = Math.max(window.scrollY, scrollRoot?.scrollTop || 0);
      transparentHeader.classList.toggle('tc-header-scrolled', scrollPosition > 32);
    };
    syncHeader();
    window.addEventListener('scroll', syncHeader, { passive: true });
    scrollRoot?.addEventListener('scroll', syncHeader, { passive: true });
  }

  const mobileMenu = document.querySelector('.tc-mobile-menu > details');
  if (mobileMenu) {
    const pageScrollRoot = document.querySelector('.page-wrapper');
    const menuSummary = mobileMenu.querySelector(':scope > summary');
    let closeTimer;

    const closeMobileMenu = () => {
      if (!mobileMenu.open || mobileMenu.classList.contains('tc-mobile-menu--closing')) return;
      if (reduceMotion.matches) {
        mobileMenu.open = false;
        return;
      }
      mobileMenu.classList.add('tc-mobile-menu--closing');
      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(() => {
        mobileMenu.open = false;
        mobileMenu.classList.remove('tc-mobile-menu--closing');
      }, 220);
    };

    const closeMenuOnPageScroll = () => {
      closeMobileMenu();
    };

    menuSummary?.addEventListener('click', (event) => {
      if (!mobileMenu.open) return;
      event.preventDefault();
      closeMobileMenu();
    });
    window.addEventListener('scroll', closeMenuOnPageScroll, { passive: true });
    pageScrollRoot?.addEventListener('scroll', closeMenuOnPageScroll, { passive: true });
  }

  document.querySelectorAll('[data-tc-announcement]').forEach((bar) => {
    const items = [...bar.querySelectorAll('[data-tc-announcement-item]')];
    if (items.length < 2 || reduceMotion.matches) return;
    let active = 0;
    window.setInterval(() => {
      items[active].setAttribute('aria-hidden', 'true');
      active = (active + 1) % items.length;
      items[active].setAttribute('aria-hidden', 'false');
    }, Number(bar.dataset.speed || 5) * 1000);
  });

  document.querySelectorAll('[data-tc-sort]').forEach((select) => {
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.assign(url.toString());
    });
  });

  document.querySelectorAll('[data-tc-product-form]').forEach((form) => {
    const select = form.querySelector('[data-tc-product-select]');
    const button = form.querySelector('[data-tc-product-submit]');
    const stickyButton = document.querySelector(`[data-tc-sticky-submit="${form.id}"]`);
    if (!select || !button) return;
    const syncVariant = () => {
      const option = select.options[select.selectedIndex];
      const available = option?.dataset.available === 'true';
      button.disabled = !available;
      button.textContent = available ? 'Add to bag' : 'Sold out';
      if (stickyButton) {
        stickyButton.disabled = !available;
        stickyButton.textContent = available ? 'Add to bag' : 'Sold out';
      }
    };
    select.addEventListener('change', syncVariant);
    syncVariant();
  });

  document.querySelectorAll('[data-tc-carousel]').forEach((carousel) => {
    const mobileQuery = window.matchMedia('(max-width: 749px)');
    const originalSlides = [...carousel.querySelectorAll('[data-tc-slide]')];
    const supportsScrollEnd = 'onscrollend' in carousel;
    let leadingClones = [];
    let trailingClones = [];
    let scrollTimer;
    let resizeFrame;
    let active = false;

    const slideLeft = (slide) => {
      const paddingLeft = Number.parseFloat(window.getComputedStyle(carousel).paddingLeft) || 0;
      return slide.offsetLeft - paddingLeft;
    };

    const closestSlide = (slides) => slides.reduce((closest, slide) => (
      Math.abs(slideLeft(slide) - carousel.scrollLeft) < Math.abs(slideLeft(closest) - carousel.scrollLeft)
        ? slide
        : closest
    ));

    const jumpTo = (slide) => {
      if (!slide) return;
      carousel.classList.add('tc-carousel-jumping');
      carousel.scrollLeft = slideLeft(slide);
      window.requestAnimationFrame(() => window.requestAnimationFrame(() => {
        carousel.classList.remove('tc-carousel-jumping');
      }));
    };

    const allSlides = () => [...carousel.querySelectorAll('[data-tc-slide]')];

    const settleLoop = () => {
      if (!active) return;
      const current = closestSlide(allSlides());
      if (!current.dataset.tcClone) return;
      jumpTo(originalSlides[Number(current.dataset.tcOriginalIndex)]);
    };

    const onScroll = () => {
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(settleLoop, 120);
    };

    const onKeydown = (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      const slides = allSlides();
      const currentIndex = slides.indexOf(closestSlide(slides));
      const direction = event.key === 'ArrowRight' ? 1 : -1;
      const target = slides[Math.max(0, Math.min(slides.length - 1, currentIndex + direction))];
      carousel.scrollTo({
        left: slideLeft(target),
        behavior: reduceMotion.matches ? 'auto' : 'smooth'
      });
    };

    const onResize = () => {
      window.cancelAnimationFrame(resizeFrame);
      resizeFrame = window.requestAnimationFrame(() => {
        if (!active) return;
        const current = closestSlide(allSlides());
        jumpTo(originalSlides[Number(current.dataset.tcOriginalIndex)] || originalSlides[0]);
      });
    };

    const prepareClone = (slide, position, index) => {
      const clone = slide.cloneNode(true);
      clone.dataset.tcClone = position;
      clone.dataset.tcOriginalIndex = String(index);
      clone.setAttribute('aria-hidden', 'true');
      clone.inert = true;
      clone.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((element) => {
        element.setAttribute('tabindex', '-1');
      });
      return clone;
    };

    const initialise = () => {
      if (active || originalSlides.length < 2) return;
      originalSlides.forEach((slide, index) => { slide.dataset.tcOriginalIndex = String(index); });
      leadingClones = originalSlides.map((slide, index) => prepareClone(slide, 'leading', index));
      trailingClones = originalSlides.map((slide, index) => prepareClone(slide, 'trailing', index));
      const leadingFragment = document.createDocumentFragment();
      const trailingFragment = document.createDocumentFragment();
      leadingClones.forEach((clone) => leadingFragment.append(clone));
      trailingClones.forEach((clone) => trailingFragment.append(clone));
      carousel.insertBefore(leadingFragment, carousel.firstChild);
      carousel.append(trailingFragment);
      active = true;
      carousel.dataset.tcLoopActive = 'true';
      carousel.addEventListener('keydown', onKeydown);
      if (supportsScrollEnd) carousel.addEventListener('scrollend', settleLoop);
      else carousel.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onResize, { passive: true });
      window.requestAnimationFrame(() => jumpTo(originalSlides[0]));
    };

    const destroy = () => {
      if (!active) return;
      window.clearTimeout(scrollTimer);
      window.cancelAnimationFrame(resizeFrame);
      carousel.removeEventListener('keydown', onKeydown);
      carousel.removeEventListener('scrollend', settleLoop);
      carousel.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onResize);
      [...leadingClones, ...trailingClones].forEach((clone) => clone.remove());
      leadingClones = [];
      trailingClones = [];
      originalSlides.forEach((slide) => { delete slide.dataset.tcOriginalIndex; });
      active = false;
      delete carousel.dataset.tcLoopActive;
      carousel.classList.remove('tc-carousel-jumping');
      carousel.scrollLeft = 0;
    };

    const sync = () => {
      if (mobileQuery.matches) initialise();
      else destroy();
    };

    if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', sync);
    else mobileQuery.addListener(sync);
    sync();
  });

  const revealTargets = [...document.querySelectorAll([
    '.tc-section__header',
    '.tc-product-card',
    '.tc-polaroid-wall',
    '.tc-footer__signup',
    '.tc-about__copy',
    '.tc-collection__header',
    '.tc-collection__toolbar',
    '.tc-product__details'
  ].join(','))];

  if (revealTargets.length && !reduceMotion.matches && !connection?.saveData && 'IntersectionObserver' in window) {
    document.documentElement.classList.add('tc-motion-ready');
    revealTargets.forEach((target, index) => {
      target.classList.add('tc-reveal-target');
      target.style.setProperty('--tc-reveal-delay', `${(index % 4) * 55}ms`);
    });

    const revealObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -7% 0px', threshold: .08 });

    revealTargets.forEach((target) => revealObserver.observe(target));
  }

  const popup = document.querySelector('[data-tc-popup]');
  if (!popup) return;

  const closeButton = popup.querySelector('[data-tc-popup-close]');
  const panel = popup.querySelector('.tc-popup__panel');
  const delay = Number(popup.dataset.delay || 15) * 1000;
  const threshold = Number(popup.dataset.scroll || 50) / 100;
  const storageKey = 'tc-newsletter-popup-seen';
  const popupScrollRoot = document.querySelector('.page-wrapper');
  let opened = false;
  let timer;
  let onPopupScroll;

  const isSuppressed = () => {
    try { return sessionStorage.getItem(storageKey) === 'true'; }
    catch (_) { return false; }
  };

  const rememberVisit = () => {
    try { sessionStorage.setItem(storageKey, 'true'); }
    catch (_) {}
  };

  const show = (force = false) => {
    if (!popup.hidden) return;
    if (!force && (opened || isSuppressed())) return;
    opened = true;
    rememberVisit();
    popup.hidden = false;
    document.body.style.overflow = 'hidden';
    window.clearTimeout(timer);
    if (onPopupScroll) {
      window.removeEventListener('scroll', onPopupScroll);
      popupScrollRoot?.removeEventListener('scroll', onPopupScroll);
    }
    window.requestAnimationFrame(() => closeButton?.focus());
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest?.('[data-tc-open-popup]');
    if (!trigger) return;
    event.preventDefault();
    show(true);
  });

  const close = () => {
    popup.hidden = true;
    document.body.style.overflow = '';
  };

  if (popup.dataset.success === 'true') show(true);
  else if (!isSuppressed()) {
    timer = window.setTimeout(show, delay);
    onPopupScroll = () => {
      const documentScrollable = document.documentElement.scrollHeight - window.innerHeight;
      const documentProgress = documentScrollable > 0 ? window.scrollY / documentScrollable : 0;
      const rootScrollable = popupScrollRoot ? popupScrollRoot.scrollHeight - popupScrollRoot.clientHeight : 0;
      const rootProgress = rootScrollable > 0 ? popupScrollRoot.scrollTop / rootScrollable : 0;
      if (Math.max(documentProgress, rootProgress) >= threshold) {
        show();
      }
    };
    window.addEventListener('scroll', onPopupScroll, { passive: true });
    popupScrollRoot?.addEventListener('scroll', onPopupScroll, { passive: true });
  }

  closeButton?.addEventListener('click', close);
  popup.querySelector('.tc-popup__backdrop')?.addEventListener('click', close);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !popup.hidden) close();
    if (event.key !== 'Tab' || popup.hidden || !panel) return;
    const focusable = [...panel.querySelectorAll('button, a, input, select, textarea, [tabindex]:not([tabindex="-1"])')]
      .filter((element) => !element.disabled && element.offsetParent !== null);
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
})();
